import React from 'react';
import { Link } from 'react-router-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { isDataManager } from '../../../role/roleUtils';
import earthquakeImage from '../../../assets/earthquake.jpg';
import tsunamiImage from '../../../assets/tsunami.jpg';
import volcanoImage from '../../../assets/volcano.jpg';

// eslint-disable-next-line react/prefer-stateless-function
export class About extends React.Component {
  componentDidMount() {
    document.title = 'NCEI Global Historical Hazard Database';
  }

  render() {
    const { authorities } = this.props;

    return (
      <div className="haz-about-page">
        <div className="row">
          <div className="col">
            <br />
            <h1>Natural Hazards Data</h1>
            <hr />

            <p className="intro">
              NCEI archives and assimilates tsunami, earthquake,
              and volcano data to support research, planning, response, and
              mitigation. Long-term data can be used to establish the history of
              natural hazard occurrences and help mitigate against future
              events. The natural hazards datasets are available through the HazEL (Hazardous Event Lookup) interface, developed by NCEI.
            </p>
          </div>
        </div>

        <div className="row">

          <div className="col-lg-3 box">
            <div className="card">
              <div className="cardHeader">
                <h2>Earthquakes</h2>
                <div className="imageFrame">
                  <img src={earthquakeImage} className="preview" alt="" />
                </div>
              </div>
              <br />
              <div className="subcard">
                <h3>
                  <Link to="/view/hazards/earthquake/eartquake-search/" title="NCEI/WDS Earthquakes"><u className="searchLink">NCEI/WDS Earthquakes</u></Link>
                </h3>
                <h4>
                  <a href="http://dx.doi.org/10.7289/V5TD9V7K" rel="noopener noreferrer" target="_blank" title="Earthquake DOI Information" aria-label="Earthquake DOI Information">Earthquake DOI Information</a>
                </h4>
                {isDataManager(authorities) && (
                <h3 className="dataManager"><Link to="/view/hazards/earthquake/update/" title="Add Earthquake Event"><u>Add Earthquake Event</u></Link></h3>
                )}
                <p>
                  The Significant Earthquake Database contains
                  information on destructive earthquakes from 2150 B.C. to the
                  present that meet at least one of the following criteria:
                  Moderate damage (approximately $1 million or more), 10 or more
                  deaths, Magnitude 7.5 or greater, Modified Mercalli Intensity
                  X or greater, or the earthquake generated a tsunami.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6 box">
            <div className="card">

              <div className="cardHeader">
                <h2>Tsunamis</h2>
                <div className="imageFrame">
                  <img src={tsunamiImage} className="preview" alt="" />
                </div>
              </div>

              <br />

              {/* top row of tsunami */}
              <div className="flex-grid">
                <div className="row">

                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="subcard">
                      <h3>
                        <Link to="/view/hazards/tsunami/event-search/" title="NCEI/WDS Tsunami Events"><u className="searchLink">NCEI/WDS Tsunami Events</u></Link>
                      </h3>
                      <h4>
                        <a href="http://dx.doi.org/10.7289/V5PN93H7" rel="noopener noreferrer" target="_blank" title="Tsunami DOI Information" aria-label="Tsunami DOI Information">Tsunami DOI Information</a>
                      </h4>
                      {isDataManager(authorities) && (
                      <h3 className="dataManager"><Link to="/view/hazards/tsunami/update-tsunami/" title="Add Tsunami Event"><u>Add Tsunami Event</u></Link></h3>
                      )}
                      <p>
                        The NCEI/WDS Tsunami Event Database contains
                        information on the source of the tsunami.
                        It is related to the Tsunami Runup database which contains
                        information on locations where tsunami effects occurred.
                      </p>
                    </div>
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="subcard">
                      <h3>
                        <Link to="/view/hazards/tsunami/runup-search/" title="NCEI/WDS Tsunami Runups"><u className="searchLink">NCEI/WDS Tsunami Runups</u></Link>
                      </h3>
                      <h4>
                        <a href="http://dx.doi.org/10.7289/V5PN93H7" rel="noopener noreferrer" target="_blank" title="Runup DOI Information" aria-label="Runup DOI Information">Runup DOI Information</a>
                      </h4>
                      {isDataManager(authorities) && (
                      <h3 className="dataManager"><Link to="/view/hazards/tsunami/update-runup/" title="Add Tsunami Runup"><u>Add Tsunami Runup</u></Link></h3>
                      )}
                      <p>
                        The NCEI/WDS Tsunami Runup Database contains
                        information on locations where tsunami effects occurred.
                        It is related to the Tsunami Source Event database which
                        contains information on the source of the tsunami.
                      </p>
                    </div>
                  </div>

                </div>

                {/* bottom row of tsunami */}
                <div className="row">

                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="subcard">
                      <h3>
                        <Link to="/view/hazards/tsunami/deposit-search/" title="NCEI/WDS Tsunami Deposits"><u className="searchLink">NCEI/WDS Tsunami Deposits</u></Link>
                      </h3>
                      <h4>
                        <a href="https://data.noaa.gov/metaview/page?xml=NOAA/NESDIS/NGDC/MGG/Hazards//iso/xml/G10146.xml&view=getDataView&header=none" rel="noopener noreferrer" target="_blank" title="Deposit DOI Information" aria-label="Deposit DOI Information">Deposit Data Information</a>
                      </h4>
                      {isDataManager(authorities) && (
                      <h3 className="dataManager"><Link to="/view/hazards/tsunami/update-deposit/" title="Add Tsunami Deposit"><u>Add Tsunami Deposit</u></Link></h3>
                      )}
                      <p>
                        Tsunami deposits are the physical evidence left
                        behind when a tsunami impacts a shoreline or affects submarine
                        sediments. These deposits can be preserved in the geologic
                        record and studied long after the tsunami waves dissipate.
                      </p>
                    </div>
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="subcard">
                      <h3>
                        <Link to="/view/hazards/tsunami/marigram-search/" title="NCEI Marigram Records"><u className="searchLink">NCEI Marigram Records</u></Link>
                      </h3>
                      {/*
                      {isDataManager(authorities) && (
                      <h3 className="dataManager"><Link to="/view/hazards/tsunami/update-marigram/" title="Add Marigram Record"><u>Add Marigram Record</u></Link></h3>
                      )}
                      */}
                      <p>
                        NCEI converts tsunami marigrams from analog (microfiche) to high-resolution digital images. Microfiche were created in the 1970s from deteriorating paper records. The collection includes records from 1854 to 1994.
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          {/* end tsunamis */}

          <div className="col-lg-3 box">
            <div className="card">
              <div className="cardHeader">
                <h2>Volcanoes</h2>
                <div className="imageFrame">
                  <img src={volcanoImage} className="preview" alt="" />
                </div>
              </div>
              <br />
              <div className="subcard">
                <h3>
                  <Link to="/view/hazards/volcano/loc-search/" title="NCEI Volcano Locations"><u className="searchLink">NCEI Volcano Locations</u></Link>
                </h3>
                <h4>
                  <a href="https://data.noaa.gov/metaview/page?xml=NOAA/NESDIS/NGDC/MGG/Hazards//iso/xml/G02135.xml&view=getDataView&header=none" rel="noopener noreferrer" target="_blank" title="Volcano Location DOI Information" aria-label="Volcano Location DOI Information">Volcano Location Data Information</a>
                </h4>
                {isDataManager(authorities) && (
                <h3 className="dataManager"><Link to="/view/hazards/volcano/loc-update/" title="Add Volcano Location"><u>Add Volcano Location</u></Link></h3>
                )}
                <p>
                  The Volcano Locations Database is a global listing of
                  over 1600 volcanoes which includes information on the
                  latitude, longitude, elevation, type of volcano, and last
                  known eruption.
                </p>
              </div>
              <div className="subcard">
                <h3>
                  <Link to="/view/hazards/volcano/event-search/" title="NCEI/WDS Volcanic Eruptions"><u className="searchLink">NCEI/WDS Volcanic Eruptions</u></Link>
                </h3>
                <h4>
                  <a href="http://dx.doi.org/10.7289/V5JW8BSH" rel="noopener noreferrer" target="_blank" title="Volcano Eruption DOI Information" aria-label="Volcano Eruption DOI Information">Volcano Eruption DOI Information</a>
                </h4>
                {isDataManager(authorities) && (
                <h3 className="dataManager"><Link to="/view/hazards/volcano/event-update/" title="Add Volcano Event"><u>Add Volcano Event</u></Link></h3>
                )}
                <p>
                  The Significant Volcanic Eruption Database is a
                  global listing of over 800 significant eruptions which
                  includes information on the latitude, longitude, elevation,
                  type of volcano, and last known eruption.
                </p>
              </div>
            </div>
          </div>
          {/* end volcanoes */}

        </div>

        {/* end clearfix */}
        {isDataManager(authorities) && (
          <div className="row">
            <div className="col">
              <div className="reference">
                <div className="card">
                  <div className="cardHead">
                    <div className="cardTitle"><h2>References</h2></div>
                  </div>
                  <div className="subcard">
                    <h3 className="dataManager">
                      <Link to="/view/reference/search/" title="Search References"><u>Search References</u></Link>
                      {' '}
                      |
                      {' '}
                      <Link to="/view/reference/update/" title="Edit References"><u>Edit References</u></Link>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <br />
      </div>
    );
  }
}

About.propTypes = {
  authorities: ImmutablePropTypes.list.isRequired,
};
